import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { HorizontalBarChartWithAxis } from '@fluentui/react-charting';
import type { IHorizontalBarChartWithAxisDataPoint } from '@fluentui/react-charting';
import { WidgetContainer } from '../WidgetContainer';
import { ChartThemeProvider } from '../ChartThemeProvider';
import { getCSATColor } from '../utils/csatColors';
import { useCSATByPurposeChartStyles } from './CSATByPurposeChart.styles';
import type { PurposeSatisfaction } from '@/types/reports';

export interface CSATByPurposeChartProps {
  data: PurposeSatisfaction[];
  titleKey: string;
}

export function CSATByPurposeChart({ data, titleKey }: CSATByPurposeChartProps) {
  const styles = useCSATByPurposeChartStyles();
  const { t } = useTranslation('reports');

  const chartData: IHorizontalBarChartWithAxisDataPoint[] = useMemo(
    () =>
      [...data]
        .sort((a, b) => b.csatScore - a.csatScore)
        .map((d) => ({
          x: d.csatScore,
          y: d.purpose,
          color: getCSATColor(d.csatScore),
        })),
    [data]
  );

  return (
    <WidgetContainer title={t(titleKey)}>
      <div className={styles.root} role="figure" aria-label={t(titleKey)}>
        <ChartThemeProvider>
          <HorizontalBarChartWithAxis
            data={chartData}
            showYAxisLables
            height={300}
            enableReflow
            hideLegend
          />
        </ChartThemeProvider>
      </div>
    </WidgetContainer>
  );
}
